import React from "react";
import Scrollable from "./shared/Scrollable";
import AlertsAccordion from "./AlertsAccordion";
import { useAccount } from "./account-context";

const OperationalRightPanelCard = ({
  impactedStoresCount,
  allStoresCount,
  activeTab,
  setActiveTab,
  storesData,
  alertsDataDisplay,
  isImpactedColor,
  openEntityWithOneDayDuration,
}) => {
  const { accountId } = useAccount();

    // const handleRowClick = useCallback((entityGuid, storeId, serviceName) => {
    //       let accountId = 3592556;
    //       console.log("Row clicked with:", { entityGuid, storeId, serviceName });
    //       let guid = btoa(`${accountId}|EXT|${serviceName}|${storeId}`).replaceAll(
    //         "=",
    //         "",
    //       );
    //     // nerdlet.setConfig({ timePickerDefaultOffset: 86400000 });
    //     navigation.openStackedEntity(guid);
    //   }, []);
    
  return (
    <div className="rt-oh-card">
      {/* Header */}
      <div className="oh-store-header">
        <span className="oh-status-dot oh-red" />
        <span className="oh-header-text">Unhealthy</span>
        <span className="oh-header-count">
          {impactedStoresCount} / {allStoresCount}
        </span>
      </div>

      {/* Tabs */}
      <div className="oh-tabs">
        <div
          className={`oh-tab ${activeTab === "right-stores" ? "active" : ""}`}
          onClick={() => setActiveTab("right-stores")}
        >
          Stores
        </div>

        <div
          className={`oh-tab ${activeTab === "right-alerts" ? "active" : ""}`}
          onClick={() => setActiveTab("right-alerts")}
        >
          Alerts
        </div>
      </div>

      {/* Stores Tab */}
      {activeTab === "right-stores" && (
        <Scrollable className="oh-scroll-container">
          
          {/* {(storesData || [])
            .filter((s) => isImpactedColor(s.color))
            .sort((a, b) => Number(a.store) - Number(b.store))
            .map((store, idx) => (
              <div
                key={`${store.store}-${idx}`}
             
                className="oh-store-row clickable"
                onClick={(e) => {
                  e.stopPropagation();

                  const entityGuid =
                    store?.guid ??
                    "MzU5MjU1NnxWSVp8REFTSEJPQVJEfGRhOjEyMjEyOTc5";

                  openEntityWithOneDayDuration(
                    entityGuid,
                    store.store, (store.issue  || "").toUpperCase(),
                    accountId
                  );
                }}
              >
                <span className="oh-store-number">{store.store}</span>
                <span className="oh-store-detail">
                  {store.detail || ""}
                </span>
              </div>
            ))} */}
           
            {/* {(storesData || [])
  .filter((s) => isImpactedColor(s.color))
  .sort((a, b) => Number(a.store) - Number(b.store))
  .flatMap((store, idx) =>
    Object.entries(store.services || {}).flatMap(
      ([serviceName, alerts]) =>
        (alerts || []).map((alert, alertIdx) => (
          <div
            key={`${store.store}-${serviceName}-${alertIdx}`}
            className="oh-store-row clickable"
            onClick={(e) => {
              e.stopPropagation();

              const entityGuid =
                alert.guid ??
                "MzU5MjU1NnxWSVp8REFTSEJPQVJEfGRhOjEyMjEyOTc5";

              openEntityWithOneDayDuration(
                entityGuid,
                store.store,
                serviceName.toUpperCase(),
                accountId
              );
            }}
          >
            <span className="oh-store-number">{store.store}</span>
            <span className="oh-store-detail">
              {alert.detail}
            </span>
          </div>
        ))
    )
  )} */}
 
 
{(storesData || [])
  .filter(
    (store) =>
      isImpactedColor(store.color) &&
      store.services &&
      Object.keys(store.services).length > 0
  )
  .sort((a, b) => Number(a.store) - Number(b.store))
  .map((store) => {
    // 1️ Get the service key dynamically (e.g. Sesame, DigitalOrdering, eProd)
    const serviceName = Object.keys(store.services)[0];

    const alerts = store.services[serviceName] || [];
//console.log("Processing store with:", { store: store.store, serviceName, alerts, store });
    // 2️ Collect and de‑duplicate details
    // const uniqueDetails = [
    //   ...new Set(
    //     alerts
    //       .map((alert) => alert.detail)
    //       .filter(Boolean)
    //   ),
    // ];

    
 const uniqueDetails = [
    ...new Set(
      alerts
        .map((a) =>
          a.alert && a.detail
            ? `${a.alert} - ${a.detail}`
            : null
        )
        .filter(Boolean)
    ),
  ];
// Group details by alert
const alertGroups = alerts.reduce((acc, a) => {
  if (!a.alert || !a.detail) return acc;

  if (!acc[a.alert]) {
    acc[a.alert] = [];
  }

  acc[a.alert].push(a.detail);
  return acc;
}, {});

    if (uniqueDetails.length === 0) return null;

    // 3️ Get a guid safely
    const guid =
      alerts.find((a) => a?.guid)?.guid ??
      "NOGUID";

    return (
      <div
        key={`${store.store}-${serviceName}`}
        className="oh-store-row clickable" //
        onClick={(e) => {
          e.stopPropagation();
console.log("Clicked store row with:", { guid, store: store.store, serviceName: serviceName.toUpperCase(), accountId });
          openEntityWithOneDayDuration(
            guid,
            store.store,
            serviceName.toUpperCase(), //  DYNAMIC & CAPITALIZED
            accountId,
           'alert'
          );
        }}
      >
        <span className="oh-store-number">
          {store.store}
        </span>

        <span className="oh-store-detail">
          {/* {uniqueDetails.join(", ")} */}
          
{Object.entries(alertGroups).map(([alertName, details]) => (
  <div key={alertName}>
    {alertName} - {" "}
    {[...new Set(details)].join(", ")}
  </div>
))}

        </span>
      </div>
    );
  })}

        </Scrollable>
      )}

      {/* Alerts Tab */}
      {activeTab === "right-alerts" && (
        <Scrollable className="oh-scroll-container">
          <AlertsAccordion
            alertsData={alertsDataDisplay}
            onStoreClick={(guid, store, service,alertgroup

            ) => {
             // console.log("Clicked:", guid, store, service,accountId);
               openEntityWithOneDayDuration(
                    guid,
                    store,
                    service,
                    accountId,
                    alertgroup
                  );
            }}
          />
        </Scrollable>
      )}
    </div>
  );
};

export default OperationalRightPanelCard;